import _defineProperty from "C:\\Users\\SB user\\Desktop\\Morpho\\website\\MPS_WEB\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var genStepsVerticalStyle = function genStepsVerticalStyle(token) {
  var _$concat, _$concat$concat, _$concat2;

  var componentCls = token.componentCls,
      stepsSmallIconSize = token.stepsSmallIconSize,
      stepsIconSize = token.stepsIconSize;
  return _defineProperty({}, "&".concat(componentCls, "-vertical"), (_$concat2 = {
    display: 'flex',
    flexDirection: 'column'
  }, _defineProperty(_$concat2, "> ".concat(componentCls, "-item"), (_$concat = {
    display: 'block',
    flex: '1 0 auto',
    paddingInlineStart: 0,
    overflow: 'visible'
  }, _defineProperty(_$concat, "".concat(componentCls, "-item-icon"), {
    float: 'left',
    marginInlineEnd: token.margin
  }), _defineProperty(_$concat, "".concat(componentCls, "-item-content"), {
    display: 'block',
    minHeight: token.controlHeight * 1.5,
    overflow: 'hidden'
  }), _defineProperty(_$concat, "".concat(componentCls, "-item-title"), {
    lineHeight: "".concat(stepsIconSize, "px")
  }), _defineProperty(_$concat, "".concat(componentCls, "-item-description"), {
    paddingBottom: token.paddingSM
  }), _$concat)), _defineProperty(_$concat2, "> ".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    position: 'absolute',
    top: 0,
    insetInlineStart: token.stepsIconSize / 2 - token.lineWidth,
    width: token.lineWidth,
    height: '100%',
    padding: "".concat(stepsIconSize + token.marginXXS * 1.5, "px 0 ").concat(token.marginXXS * 1.5, "px"),
    '&::after': {
      width: token.lineWidth,
      height: '100%'
    }
  }), _defineProperty(_$concat2, "> ".concat(componentCls, "-item:not(:last-child) > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    display: 'block'
  }), _defineProperty(_$concat2, " > ".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-content > ").concat(componentCls, "-item-title"), {
    '&::after': {
      display: 'none'
    }
  }), _defineProperty(_$concat2, "&".concat(componentCls, "-small ").concat(componentCls, "-item-container"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "".concat(componentCls, "-item-tail"), {
    position: 'absolute',
    top: 0,
    insetInlineStart: token.stepsSmallIconSize / 2 - token.lineWidth,
    padding: "".concat(stepsSmallIconSize + token.marginXXS * 1.5, "px 0 ").concat(token.marginXXS * 1.5, "px")
  }), _defineProperty(_$concat$concat, "".concat(componentCls, "-item-title"), {
    lineHeight: "".concat(stepsSmallIconSize, "px")
  }), _$concat$concat)), _$concat2));
};

export default genStepsVerticalStyle;